import DataSource from "devextreme/data/data_source";
import {
  TreeList, RemoteOperations, Column, Editing, Texts, Button, SearchPanel, HeaderFilter, Scrolling, Paging, Pager,
} from 'devextreme-react/tree-list';
import 'whatwg-fetch';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { t } from 'i18next';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';
import menuService from '@/projects/admin/services/menu-service';
import PermissionWrapper from "@/core/wrappers/permission-wrapper";
import { checkPermission } from "@/modules/auth/core/AuthHelpers";
import { applicationService } from "@/projects/admin/services/application-service";
import { ROUTER_CONSTANTS } from "@/core/constants/common/router-constants";

const mainStore = new CustomStore({
  key: 'id',
  load: menuService.getAllMenu,
  byKey: async (key, loadOptions: any) => {
    var returnObject = null;
    if (key) {
      loadOptions.filter = ["id", "=", key];
      const objectsByID = (await menuService.getAllMenu(loadOptions))
      returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
    }
    return returnObject
  },
  remove: menuService.deleteMenu,
  useDefaultSearch: true
});

const applicationStore = new CustomStore({
  key: 'id',
  load: applicationService.lookupApplication,
  byKey: async (key, loadOptions: any) => {
    let returnObject = null;
    if (key) {
      loadOptions.filter = ["id", "=", key];
      const objectsByID = (await applicationService.lookupApplication(loadOptions))
      returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
    }
    return returnObject
  },
  useDefaultSearch: true
});

const dataSource = new DataSource({
  store: mainStore,
});
const allowedPageSizes = [20, 50, 100];
const MenuList = () => {
  const navigate = useNavigate();
  const goToDefinitionPage = async () => {
    navigate(`/admin/${ROUTER_CONSTANTS.ADMIN.MenuDefinition}`)
  }
  const goToEdit = (id: string) => {
    navigate(`/admin/${ROUTER_CONSTANTS.ADMIN.MenuList}/${id}`, { state: { id: id } })
  }

  return (
    <React.Fragment>
      <PermissionWrapper permission="Admin.Menu.Menu" action="Create">
        <FormWrapper
          isAddBackBtn={false}
          addNewRecord={goToDefinitionPage}
          buttonGroups={[
            { buttonOptions: BUTTON_CONSTANTS.NewRecordBtn }
          ]}
        />
      </PermissionWrapper>
      <TreeList
        id="menuList"
        dataSource={dataSource}
        keyExpr="id"
        parentIdExpr="parentId"
        hasItemsExpr="hasItems"
        rootValue={null}
        showRowLines={true}
        showBorders={true}
        showColumnLines={false}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        autoExpandAll={false}
      >
        <RemoteOperations filtering={true} sorting={true} grouping={true} />
        <SearchPanel visible={true} />
        <HeaderFilter visible={true} />
        <Editing
          allowDeleting={checkPermission("Admin.Menu.Menu", "Delete")}
          allowUpdating={checkPermission("Admin.Menu.Menu", "Update")}
          confirmDelete={true}
        >
          <Texts
            confirmDeleteMessage={t('the_menu_will_be_deleted_are_you_sure')}
            confirmDeleteTitle={t('warning')}
          />
        </Editing>
        <Scrolling
          mode="standard" useNative={true} />
        <Paging
          enabled={true}
          defaultPageSize={10} />
        <Pager
          showNavigationButtons={true}
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showInfo={true} />
        <Column dataField="text" caption={t('menu_text')} />
        <Column dataField="order" caption={t('menu_order')} sortIndex={1} sortOrder="asc" />
        <Column dataField="applicationId" caption={t('application')} sortIndex={0} sortOrder="desc"
          lookup={{
            dataSource: applicationStore,
            valueExpr: 'id',
            displayExpr: 'name'
          }} />
        <Column dataField="applicationFeature" caption={t('feature')} />
        <Column type="buttons"  >
          <Button
            name="edit"
            onClick={function (e: any) {
              goToEdit(e.row?.data.id);
            }}
          />
          <Button
          name="delete"
          
        />
        </Column>
      </TreeList>
    </React.Fragment>
  )
};
export default MenuList